import { FC, ReactNode } from 'react';
import styles from './main.scss';
import classnames from 'classnames';
import ExclamationCircle from 'dibs-icons/exports/legacy/ExclamationCircle';
import CircleCheck from 'dibs-icons/exports/legacy/CircleCheck';

type BannerProps = {
    message: ReactNode;
    bannerType: 'error' | 'success';
    bodyClassName?: string;
};

export const Banner: FC<BannerProps> = (props: BannerProps) => {
    const { message, bannerType, bodyClassName } = props;
    let bannerTypeClass = '';
    let icon: ReactNode;

    switch (bannerType) {
        case 'error': {
            icon = <ExclamationCircle className={styles.icon} />;
            bannerTypeClass = styles.errorBody;
            break;
        }
        case 'success': {
            icon = <CircleCheck className={styles.icon} />;
            bannerTypeClass = styles.successBody;
        }
    }

    return (
        <div className={classnames(styles.body, bodyClassName, bannerTypeClass)}>
            {icon}
            <span>{message}</span>
        </div>
    );
};
